import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 44 44",
    class: "icon-fi icon-fi-radio-btn-on"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createStaticVNode("<g class=\"\"><rect width=\"44\" height=\"44\" class=\"icon-fi--no-fill\"></rect></g><g class=\"\"><circle cx=\"22\" cy=\"22\" r=\"10\" class=\"icon-fi--no-fill icon-fi--with-stroke\"></circle><circle cx=\"22\" cy=\"22\" r=\"7\" class=\"\"></circle></g>", 2)
  ]), 16))
}
export default { render: render }